export const AUTH_SLICE_NAME = 'auth';

export interface AuthSliceState {
  isLoading: boolean;
  isSignOutLoading: boolean;

  isRememberMe: boolean;
  hasUserSignedIn: boolean;

  forgotPasswordEmail?: string;
  forgotPasswordCode?: string;

  formUserName: string;
  formUserEmail: string;
  formUserPassword: string;

  preFilledLoginEmail?: string;
  signUpExistingUserErrorId?: string;
}
